
import createIcon from "./createIcon";

export const ItalicIcon = createIcon('Italic', (props) => {
  return (
    <svg {...props}>
      <path d="M10.6 3.04L6.66 13.11L5.19 12.54L9.13 2.46L10.6 3.04Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
    </svg >
  )
});
